/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class STDataSourceEditorApi {
  async PreviewDataSource(query : string, type : string) : Promise<st.PreviewDataSourceResult> {
    return await componentApi.call('st', 'st-data-source-editor', 'STDataSourceEditorApi', 'PreviewDataSource', {
      query,
      type,
    });
  }
}
export default new STDataSourceEditorApi()
